import React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";

interface ConfirmDialogProps {
    open: boolean;
    onCancel: () => void;
    onDiscard: () => void;
    onConfirm: () => void;
}

export const ConfirmSaveDialog = ({open, onCancel, onDiscard, onConfirm}: ConfirmDialogProps) => (
    <Dialog open={open} onClose={onCancel}>
        <DialogTitle>Änderungen speichern?</DialogTitle>
        <DialogContent>
            <DialogContentText>Sollen die Änderungen gespeichert werden?</DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Abbruch</Button>
            <Button onClick={onDiscard}>Änderungen verwerfen</Button>
            <Button onClick={onConfirm} autoFocus>Speichern</Button>
        </DialogActions>
    </Dialog>
);
